<template>
    <div class="kefu" >
        <div>
            <div class="floor-first">
                    <a-tooltip placement="left">
                        <template #title>
                            <span>返回首页</span>
                        </template>
                        <a class="item home"  @click="goHome"></a>
                    </a-tooltip>
            </div>
            <div class="floor">
                <a-tooltip placement="left">
                    <template #title>
                        <span>客服电话：{{config.Phone}}</span>
                    </template>
                    <a class="item phone" href="javascript:"></a>
                </a-tooltip>
            </div>
            <div class="floor">
                <a-tooltip placement="left">
                    <template #title>
                        <span>QQ在线客服</span>
                    </template>
                    <a class="item qq" target="_blank" :href="'http://wpa.qq.com/msgrd?v=3&uin='+config.QQOne+'&site=qq&menu=yes'"></a>
                </a-tooltip>

                <!-- <el-tooltip class="item" effect="light" content="" placement="left"> -->
                    
                <!-- </el-tooltip> -->
            </div>
            <div class="floor" v-if="config.WeiXinUrl!=null&&config.WeiXinUrl!=''">
                <a-tooltip placement="left">
                    <template #title>
                        <div style="padding:10px">
                            <img  :src="config.WeiXinUrl" width="100" height="100"/>
                            <div class="miaoshu" style="margin-top:10px">微信客服</div>
                        </div>
                    </template>
                    <a class="item weixin" href="javascript:"></a>
                </a-tooltip>
            </div>
            <div class="floor-end" v-if="config.GongZhongHaoUrl!=null&&config.GongZhongHaoUrl!=''">
                <a-tooltip placement="left">
                    <template #title>
                        <div style="padding:10px">
                            <img  :src="config.GongZhongHaoUrl" width="100" height="100"/>
                            <div class="miaoshu" style="margin-top:10px">微信公众号</div>
                        </div>
                    </template>
                    <a class="item qrcode" href="javascript:"></a>
                </a-tooltip>
            </div>
        </div>
    </div>
</template>
<script>
import {getConfig} from '@/request.js'
export default {
    data(){
        return {
            config:{},
        }
    },
    created(){
        getConfig({},(res)=>{
            this.config= res.Result;
        })
    },
    methods: {
        goHome(){
            this.$router.push({
                path: `/index`,
            })
        },
    }
}
</script>
<style scoped>
.miaoshu{
    font-size:10px;width:100%;text-align:center;color:#909399
}
.floor-first{
    border-bottom: 1px solid #f2f2f2;
    position: relative;
    box-sizing: border-box;
}
.floor{
    border-bottom: 1px solid #f2f2f2;
    position: relative;
    box-sizing: border-box;
}
.floor-end{
    border-bottom: 1px solid #f2f2f2;
    position: relative;
    box-sizing: border-box;
}
.kefu:hover{
    opacity: 1.0;
}
.kefu{
    border: 1px solid rgba(0, 0, 0, 0.06);
    background-color:#fff;
    opacity: 1.0;
    position: fixed;
    right: 5px;
    z-index: 99999;
    transform: translateY(300px);
}
.item:hover{
    transform:scale(1.1);
    background-color:#e4e4e4;
}
.item{
    cursor: pointer;
    width: 50px;
    height: 50px;
    z-index: 9999;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    background-position: center center;
    background-size: 25px 25px;
}
.home{
    background-image: url('https://hlqimg.oss-cn-heyuan.aliyuncs.com/home.svg');
}
.phone{
    background-image: url('https://hlqimg.oss-cn-heyuan.aliyuncs.com/phone.svg');
}
.qq{
    background-image: url('https://hlqimg.oss-cn-heyuan.aliyuncs.com/qq.svg');
}
.weixin{
    background-image: url('https://hlqimg.oss-cn-heyuan.aliyuncs.com/wechat.svg');
}
.qrcode{
    background-image: url('https://hlqimg.oss-cn-heyuan.aliyuncs.com/code.svg');
}
</style>